import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { Card, CardSearchMobile } from 'loyal-react'
import { actions as cartActions } from 'features/Cart'
import { getAvailability } from './actions'
import { getProduct } from './selector'
import { actions as wishlistActions } from 'Participant/Wishlist'

class SearchCardContainer extends Component {
  componentDidMount () {
    if (!this.props.hasPriceUpdated) {
      const {
        sku,
        vendor: { id: vendorId },
        originalId
      } = this.props

      this.props.getAvailability({ sku, vendorId, originalId })

      this.inWishlist(sku, vendorId)
    }
  }

  inWishlist (props) {
    for (var i in this.props.wishlist.groupedWishlistBySkuId) {
      if (this.props.wishlist.groupedWishlistBySkuId[i].skuId === props.sku) {
        return true
      }
    }
    return false
  }

  verifyOnlyCash (props) {
    if (props.onlyCash && props.availability && props.availability.cash) {
      return props.availability ? props.availability.cash.price : false
    }
  }

  bottomOnlyCash (props) {
    if (props.onlyCash) {
      return props.availability ? props.availability.cash : null
    } else {
      return props.availability
        ? props.availability.pointCash
          ? props.availability.pointCash
          : props.availability.pointsCash
        : null
    }
  }

  render () {
    return (
      <Fragment>
        <Card
          inWishlist={this.inWishlist(this.props)}
          onlyCash={this.props.onlyCash}
          sellingPrice={this.verifyOnlyCash(this.props)}
          cashBack={this.props.cashBack}

          key={this.props.key}
          cardClass='col-6 col-lg-4 mb-2 px-1 d-none d-md-block'
          sku={this.props.sku}
          image={this.props.imageUrl}
          description={this.props.name}
          priceFrom={
            this.props.availability
              ? this.props.availability.regularPrice.toString()
              : ''
          }
          priceFor={
            this.props.availability
              ? this.props.availability.price.toString()
              : ''
          }
          poinstPlusCash={this.bottomOnlyCash(this.props)}
          countDown={this.props.countDown ? this.props.countDown : false}
          {...this.props}
          vendor={this.props.vendor}
          addCart={this.props.addItemToCart}
          itemCart={{
            sku: this.props.sku,
            vendorId: this.props.vendor.id,
            email: this.props.email
          }}
          cart={this.props.cart}
          addWishList={this.props.addWishlist}
          removeWishList={this.props.removeWishlistCard}
          available={
            this.props.availability && this.props.availability.available
          }
          decimalPlace={this.props.currencyConfiguration.decimalPlaces}
          pointsName={this.props.currencyConfiguration.pointsName}
          clearError={this.props.clearErrorCart}
          redirect={this.props.redirect}
        />
        <CardSearchMobile
          inWishlist={this.inWishlist(this.props)}
          onlyCash={this.props.onlyCash}
          cashBack={this.props.cashBack}

          sellingPrice={this.verifyOnlyCash(this.props)}
          key={this.props.key}
          cardClass='col-12 mb-1 px-half d-block d-md-none card-mobile'
          sku={this.props.sku}
          image={this.props.imageUrl}
          description={this.props.name}
          priceFrom={
            this.props.availability
              ? this.props.availability.regularPrice.toString()
              : ''
          }
          priceFor={
            this.props.availability
              ? this.props.availability.price.toString()
              : ''
          }
          poinstPlusCash={this.bottomOnlyCash(this.props)}
          countDown={this.props.countDown ? this.props.countDown : false}
          {...this.props}
          vendor={this.props.vendor}
          addCart={this.props.addItemToCart}
          itemCart={{
            sku: this.props.sku,
            vendorId: this.props.vendor.id,
            email: this.props.email
          }}
          cart={this.props.cart}
          addWishList={this.props.addWishlist}
          removeWishList={this.props.removeWishlistCard}
          available={
            this.props.availability && this.props.availability.available
          }
          decimalPlace={this.props.currencyConfiguration.decimalPlaces}
          pointsName={this.props.currencyConfiguration.pointsName}
          clearError={this.props.clearErrorCart}
          redirect={this.props.redirect}
        />
      </Fragment>
    )
  }
}

SearchCardContainer.propTypes = {
  hasPriceUpdated: PropTypes.bool.isRequired,
  addItemToCart: PropTypes.func,
  email: PropTypes.string,
  sku: PropTypes.string,
  vendor: PropTypes.object,
  originalId: PropTypes.string,
  availability: PropTypes.object,
  imageUrl: PropTypes.string,
  getAvailability: PropTypes.func,
  name: PropTypes.string,
  countDown: PropTypes.number,
  cart: PropTypes.object,
  addWishlist: PropTypes.func,
  removeWishlistCard: PropTypes.func,
  onlyCash: PropTypes.bool,
  cashBack: PropTypes.bool,
  wishlist: PropTypes.object,
  currencyConfiguration: PropTypes.object,
  clearErrorCart: PropTypes.func,
  key: PropTypes.number,
  redirect: PropTypes.func
}

const mapStateToProps = (
  { searchResult, oidc, cart, onlyCash, wishlist, catalog },
  ownProps
) => ({
  ...getProduct(searchResult, ownProps.sku),
  email: oidc && oidc.user && oidc.user.profile && oidc.user.profile.email,
  cart,
  itemAdded: cart.itemAdded,
  onlyCash,
  wishlist,
  currencyConfiguration: catalog.currencyConfiguration
})

const mapDispatchToProps = dispatch => ({
  getAvailability: (sku, vendorId, originalProductId) => {
    dispatch(getAvailability(sku, vendorId, originalProductId))
  },
  addItemToCart: (data, redirect) =>
    dispatch(cartActions.addItem(data, redirect)),
  removeWishlist: skuId => dispatch(wishlistActions.removeWishlistCard(skuId)),
  addWishlist: skuId => dispatch(wishlistActions.addWishlist(skuId)),
  clearErrorCart: () => dispatch(cartActions.clearCartError()),
  redirect: path => dispatch(push(path))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchCardContainer)



// WEBPACK FOOTER //
// ./src/features/Availability/SearchCard/SearchCardContainer.js